import React, { Component } from 'react';
import classnames from 'classnames';

import { Cell, Grid } from '../../../layout';

import { smallNumber } from '../../../../helpers/number';

import lockedRangeInputImage from '../../../../assets/images/locked-range.png';

class SpendingAreaCard extends Component {
  state = {
    barColor: this.props.value / this.props.max,
    infoCard: false,
  }

  handleInputChange = (event) => {
    const { max, onChange } = this.props;

    event.stopPropagation();

    this.setState({
      barColor: event.target.value / max
    });

    onChange(event);
  }

  showInfo = () => {
    this.setState({
      infoCard: true,
    });
  }

  render() {
    const {
      budgetReports,
      className,
      cons,
      color,
      disabled = false,
      icon,
      id,
      isSummary,
      isProtected,
      locked,
      max,
      name,
      risk,
      slug,
      value,
      description
    } = this.props;

    const { scaled, scaling } = this.state;
    const riskLabels = ['Low', 'Medium', 'High'];

    const widthMap = {
      'low': {
        width: '20%',
        color: '#cad401',
      },
      'medium': {
        width: '55%',
        color: '#f47900',
      },
      'high': {
        width: '90%',
        color: '#f40000',
      }
    };

    return (
      <div
        id={id}
        className={classnames('c-card c-card--spending', className)}
        style={{
          borderBottom: `4px solid ${color}`,
          transformOrigin: scaling ? 'top-left' : ''
        }}
      >
        <div className="c-card__front">
          <div className="c-card__oval" style={{ background: color }}>
            {icon && <img className="c-card__oval-icon" alt="Card Icon" src={`/images/icons/${icon}`} />}
          </div>

          <Grid>
            <Cell size={{ desktop: '10', tablet: '10', phone: '5' }}>
              <p className="c-card__heading">{name}</p>
              {
                (name != 'Public Health and Housing') &&
                <p>{description}</p>
              }
            </Cell>

            {
              !budgetReports &&
              <Cell size={{ desktop: '2', tablet: '2', phone: '1', }}>
                <div className="c-card__info-wrap">
                  <span className="c-card__action" onClick={() => this.props.toggleInfo(slug, 'info')}>
                    {scaled ? <i className='fa fa-times' /> : <i className='fa fa-info-circle' />}
                  </span>
                </div>
              </Cell>
            }
          </Grid>

          {
            cons &&
            <div>
              {
                cons.length > 0 &&
                (!isProtected && !locked && !budgetReports) &&
                <span className="c-card__impact-link">
                  <span className="u-cursor-pointer" onClick={() => this.props.toggleInfo(slug, 'impacts')}>
                    <i className="fas fa-exclamation-triangle" />Potential Impacts
                  </span>
                </span>
              }

              {
                ((name === 'Public Health and Housing' && locked) && isSummary) &&
                <span className={`c-card__impact-link`}>
                  <span>
                    {isSummary && <i style={{ color, }} className="fas fa-question-circle" />}
                    Why this budget is locked?
                  </span>
                </span>
              }

              {
                ((name === 'Public Health and Housing' && locked) && !isSummary) &&
                <span>
                  Budgets for Public Health and Housing can only be spent on specified activities. These budgets cannot be reduced due to the ringfenced nature of the funding for these services.
                </span>
              }
            </div>
          }

          {
            !isSummary &&
            <div className={classnames({ 'c-card__input-wrap': !isSummary })}>
              {
                !locked &&
                <p className="c-card__input-value">£{smallNumber(!isNaN(value) ? value : 0)}</p>
              }

              {
                !locked &&
                <input
                  className="c-range-input"
                  style={{
                    backgroundImage: '-webkit-gradient(linear, left top, right top, color-stop(' + this.state.barColor + ', rgb(199, 213, 0)), color-stop(' + this.state.barColor + ', gainsboro))'
                  }}
                  type="range"
                  min="0"
                  max={max}
                  value={value}
                  disabled={disabled}
                  onChange={(event) => this.handleInputChange(event)}
                  step={this.props.step}
                />
              }

              {locked && <img className="c-card__input-image" src={lockedRangeInputImage} alt="Locked Range Input" />}

              {
                !locked &&
                <p className="c-card__saving-value">
                  £{smallNumber(Number(max) - Number(value))} Savings
                </p>
              }
            </div>
          }

          {
            isSummary &&
            <div className="c-card__summary-wrap">
              {
                !isProtected &&
                <Grid>
                  {
                    slug !== 'public_health' &&
                    <Cell size={{ desktop: '7', tablet: '7', phone: '6' }}>
                      <Grid>
                        {
                          risk &&
                          <Cell size={{ desktop: '12', tablet: '12', phone: '6' }}>
                            <p className="c-card__risk-title">Risk Level</p>
                          </Cell>
                        }
                        {
                          risk && riskLabels.map((label, index) => {
                            const classes = classnames('c-card__risk-label', {
                              'c-card__risk-label--active': label === risk,
                              'u-text-center': index === 1,
                              'u-text-right': index === 2,
                            });

                            return (
                              <Cell size={{ desktop: '4', tablet: '4', phone: '2' }} key={index}>
                                <p className={classes}>{label}</p>
                              </Cell>
                            )
                          })
                        }
                        {
                          risk &&
                          <Cell size={{ desktop: '12', tablet: '12', phone: '6' }}>
                            <div className="c-card__risk-bar">
                              <span className="c-card__risk-bar-fill" style={{
                                backgroundColor: widthMap[risk].color,
                                width: widthMap[risk].width,
                              }} />
                            </div>
                          </Cell>
                        }
                      </Grid>
                    </Cell>
                  }
                  <Cell size={{ desktop: '5', tablet: '5', phone: '6' }}>
                    <p className="c-card__input-value">
                      <span className="c-card__total-spend-amount c-card__total-spend-amount--small">
                        Initial Budget: £{smallNumber(max)}
                        <br />
                        Proposed Cut: £{smallNumber(max - value)}
                      </span>
                    </p>
                  </Cell>
                </Grid>
              }

              {
                (isProtected && !budgetReports) &&
                <Grid>
                  <Cell size={{ desktop: '8', tablet: '8', phone: '6' }} alignment="bottom">
                    <p className="c-card__protected-label">
                      <span
                        className="c-card__protected-icon"
                        style={{ backgroundColor: color }}
                      />
                      <b>Budget Protected</b>
                      <i className="fas fa-check u-text-green"></i>
                    </p>
                  </Cell>
                  <Cell size={{ desktop: '4', tablet: '4', phone: '6' }}>
                    <p className="c-card__input-value">
                      <span className="c-card__total-spend-amount">£{smallNumber(value)}</span>
                    </p>
                  </Cell>
                </Grid>
              }
            </div>
          }

          <div className="card-front-overlay" />
        </div>
      </div>
    )
  }
}

export default SpendingAreaCard;



// WEBPACK FOOTER //
// ./src/components/common/cards/spending-area-card/SpendingAreaCard.jsx